export const fileTypeArray =
    ['application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/png',
        'image/jpeg',
        "application/zip",
        "application/x-zip-compressed",
        "application/dicom",
        "application/msword",
        "application/doc"

    ]

export const getFileTypeIcon = (file) => {

    let types = [...fileTypeArray]

   

    let fileTypes = {
        [types[0]]: {
            icon: require('../assets/InterBranch/PNGIcons/pdf (1).png')
        },
        [types[1]]: {
            icon: require('../assets/InterBranch/PNGIcons/doc.png')
        },
        [types[2]]: {
            icon: require('../assets/InterBranch/PNGIcons/png (1).png')
        },
        [types[3]]: {
            icon: require('../assets/InterBranch/PNGIcons/jpg (1).png')
        },
        [types[4]]: {
            icon: require('../assets/InterBranch/PNGIcons/file.png')
        },
        [types[5]]: {
            icon: require('../assets/InterBranch/PNGIcons/file.png')
        },
        [types[6]]: {
            icon: require('../assets/InterBranch/PNGIcons/file.png')
        },
        [types[7]]: {
            icon: require('../assets/InterBranch/PNGIcons/file.png')
        },
        [types[8]]: {
            icon: require('../assets/InterBranch/PNGIcons/file.png')
        },
    }


    if (types.includes(file?.file?.type)) {
        return fileTypes[file?.file?.type].icon
    }
    else {

        return fileTypes[types[4]].icon
    }


}